import $ from 'jquery';
import { Reveal } from 'foundation-sites';

window.addEventListener('load', function() {
  
  // Launch Alert Modal only once by session
  if(sessionStorage.alreadyAlerted)
    return;
  
  var alertModal = $('#alertModal');
  if(!alertModal.length)
    return;
  
  $('#modal'+alertModal.data('alertmodalid')).foundation('open');
  sessionStorage.alreadyAlerted = true;

});




